export default __webpack_public_path__ + "static/dashboard-report-data2-f3ed78dcb1ce7e061460a8e661cde4db.png";